<template>
  <v-sheet>
    Choosing Renedian
  </v-sheet>
</template>
<script>
export default {
  name: 'ChoosingRenedian',
  data: () => ({
    //
  }),
  created() {
    
  }
}
</script>